import React, { useEffect, useState } from 'react';
import './RealisticOcean.css';

const RealisticOcean = () => {
  const [scrollDepth, setScrollDepth] = useState(0);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrolled = window.scrollY;
          const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
          const depth = Math.min(scrolled / maxScroll, 1);
          setScrollDepth(depth);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="realistic-ocean-container">
      {/* Depth-based darkness overlay */}
      <div 
        className="ocean-depth-overlay" 
        style={{
          background: `radial-gradient(ellipse at center top, 
            transparent 0%, 
            rgba(0, 15, 35, ${scrollDepth * 0.4}) 30%,
            rgba(0, 8, 20, ${scrollDepth * 0.7}) 60%,
            rgba(0, 3, 10, ${scrollDepth * 0.9}) 100%)`,
        }}
      />

      {/* Static light gradient instead of animated caustics */}
      <div 
        className="static-light-gradient"
        style={{ opacity: Math.max(0, 0.8 - scrollDepth * 1.5) }}
      />

      {/* Minimal floating particles */}
      <div className="particles-layer">
        {[...Array(3)].map((_, i) => (
          <div
            key={`particle-${i}`}
            className="ocean-particle"
            style={{
              left: `${20 + i * 30}%`,
              top: `${20 + i * 25}%`,
              animationDelay: `${i * 10}s`,
              width: '2px',
              height: '2px'
            }}
          />
        ))}
      </div>


      {/* Deep sea elements (only visible when deep) */}
      {scrollDepth > 0.6 && (
        <div className="deep-sea-elements">
          <div className="bioluminescent-particle particle-1"></div>
          <div className="bioluminescent-particle particle-2"></div>
          <div className="bioluminescent-particle particle-3"></div>
        </div>
      )}

      {/* Simple static light overlay */}
      <div 
        className="simple-light-overlay"
        style={{ opacity: Math.max(0, 1 - scrollDepth * 2) }}
      />

    </div>
  );
};

export default RealisticOcean;